
import { useState, useEffect, useCallback, useRef } from 'react';
import { showToast } from '../../utils/toast';
import { cerrarSesion } from '../../Redux/usuarios';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserAuth } from '../../context/AuthContext';

const useDiferencias = (initialState, timeout = 18000000) => { // 1800000 media hora
  const [modalOpen, setModalOpen] = useState(false);
  const [loggedUser, setLoggedIn] = useState(initialState);
  const intervalRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState(Math.ceil(timeout / 1000));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { logout } = UserAuth();

  const domainKey = `expireTime_${window.location.hostname}`;

  const changeState = useCallback((state) => {
    setLoggedIn(state);
  }, []);

  const updateExpireTime = useCallback(() => {
    if (!modalOpen) {
      const expireTime = Date.now() + timeout;
      localStorage.setItem(domainKey, expireTime);
      setTimeLeft(Math.ceil(timeout / 1000));
    }
  }, [timeout, modalOpen]);

  const checkForInactivity = useCallback(() => {
    const expireTime = localStorage.getItem(domainKey);
    const timeLeft = parseInt(expireTime, 10) - Date.now();
    setTimeLeft(Math.max(0, Math.ceil(timeLeft / 1000)));
    // console.log("Faltan ", Math.max(0, Math.ceil(timeLeft / 1000)), "segundos");

    if (expireTime && timeLeft <= 30000 && !modalOpen && loggedUser) {
      setModalOpen(true);
      // console.log("Abriendo modal ", !modalOpen);
    }

    if (expireTime && timeLeft <= 0 && loggedUser) {
      changeState(false);
      setModalOpen(false);
      // console.log("Cerrando sesion y modal ", !modalOpen);
      showToast("success","Se ha cerrado la sesión por inactividad.")

      try {
        logout();
        dispatch(cerrarSesion());
        navigate('/');
        // console.log("cerraste la sesion");
      } catch (error) {
        console.log(error.message);
      }
    }
  }, [modalOpen, loggedUser, changeState, logout, navigate]);

  const handleActivity = useCallback(() => {
    setModalOpen(false);
    if (!modalOpen) {
      updateExpireTime();
    }
  }, [modalOpen, updateExpireTime]);

  useEffect(() => {
    const handleStorageEvent = (event) => {
      if (event.key === domainKey && event.newValue) {
        const newExpireTime = parseInt(event.newValue, 10);
        if (newExpireTime > Date.now()) {
          setModalOpen(false);
        }
      }
    };

    window.addEventListener('storage', handleStorageEvent);

    return () => {
      window.removeEventListener('storage', handleStorageEvent);
    };
  }, [domainKey]);

  useEffect(() => {
    if (loggedUser) {
      updateExpireTime();

      window.addEventListener("click", handleActivity);
      window.addEventListener("keypress", handleActivity);
      window.addEventListener("scroll", handleActivity);
      window.addEventListener("touchstart", handleActivity);

      intervalRef.current = setInterval(() => {
        checkForInactivity();
      }, 1000);

      return () => {
        clearInterval(intervalRef.current);
        window.removeEventListener("click", handleActivity);
        window.removeEventListener("keypress", handleActivity);
        window.removeEventListener("scroll", handleActivity);
        window.removeEventListener("touchstart", handleActivity);
      };
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }
  }, [loggedUser, updateExpireTime, checkForInactivity, modalOpen, handleActivity]);

  return { modalOpen, setModalOpen, loggedUser, changeState, timeLeft };
};

export default useDiferencias;
